import { render, staticRenderFns } from "./ComplainTypeList.vue?vue&type=template&id=ecb1f896&"
import script from "./ComplainTypeList.vue?vue&type=script&lang=js&"
export * from "./ComplainTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports